<template>
  <div id="vmap">
    <el-amap
      vid="amap"
      class="amap-demo"
      :amap-manager="amapManager"
      :center="center"
      :zoom="zoom"
      :events="mapEvents"
      map-style="dark"
    >
      <!-- 点标记在地图上显示的位置，默认为地图中心点， -->
      <el-amap-marker
        v-for="(marker,index) in polygons"
        :key="'marker'+index"
        :position="[marker.longitude,marker.latitude]"
        :events="marker.events"
      />
      <el-amap-polygon
        v-for="(polygon, index) in polygons"
        :key="index"
        :ref="`polygon_${index}`"
        :vid="index"
        :path="polygon.path"
        :editable="false"
        stroke-style="dashed"
        stroke-color="#FF0000"
        stroke-weight="2"
        :stroke-opacity="0.8"
        :fill-opacity="0.3"
        fill-color="#1791fc"
        :events="polygon.events"
      />
      <el-amap-info-window
        :position="currentWindow.position"
        :visible="currentWindow.visible"
        :events="currentWindow.events"
      >
        <div class="info">
          <div class="wrapping">
            <div class="label">项目名称:</div>
            <div class="content"><el-button type="text" @click="enterProject">{{ selectItem.projectName }}</el-button></div>
          </div>
          <div class="wrapping">
            <div class="label">项目状态:</div>
            <div class="content">{{ selectItem.projectStatusName }}</div>
          </div>
          <div class="wrapping">
            <div class="label">项目类型:</div>
            <div class="content">{{ selectItem.projectTypeName }}</div>
          </div>
          <div class="wrapping">
            <div class="label">施工许可证编号:</div>
            <div class="content">{{ selectItem.builderLicenseCode }}</div>
          </div>
          <div class="wrapping">
            <div class="label">所属地区:</div>
            <div class="content">{{ selectItem.regionName }}</div>
          </div>
          <div class="wrapping">
            <div class="label">详细地址:</div>
            <div class="content">{{ selectItem.address }}</div>
          </div>
        </div>
      </el-amap-info-window>

    </el-amap>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { AMapManager } from 'vue-amap'
import { setProject } from '@/utils/auth'
const amapManager = new AMapManager()
export default {
  props: {

  },
  data() {
    const _that = this
    return {
      amapManager,
      zoom: 5,
      markers: [],
      selectItem: {},
      mapEvents: {
        complete() {
          amapManager.getMap().setFitView()
        }
      },
      currentWindow: {
        position: [0, 0],
        content: 'dfsdfsdfsdf',
        visible: false,
        events: {
          close() {
            _that.currentWindow.visible = false
          }
        }
      },
      center: [108.170687, 34.460835]
    }
  },

  computed: {
    ...mapState({
      projectList: state => state.user.projectList,
      polygons(state) {
        const item = state.user.projectItem
        let path = []
        if (item.latLngPoints) {
          path = JSON.parse(item.latLngPoints)
        } else {
          path = []
        }
        return [
          {
            path,
            longitude: item.longitude,
            latitude: item.latitude,
            events: {
              click() {

              }
            }
          }
        ]
      }
    })
  },
  mounted() {
  },
  methods: {
    enterProject() {
      setProject(this.selectItem.projectId)
      this.$store.commit('user/SET_PROJECT_ITEM', this.selectItem)
      this.$router.push({ name: 'Dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped>
#vmap{
  width: 100%;
  height: 100%;
}
</style>
